<template>
    <div class="vue-onboarding__content v-step__content bg-primary text-left text-white" :style="!step.header && !step.action ? 'border: 1px solid #F3F2F7; border-radius: 4px;' : ''">
        <div v-if="step.content" v-html="$t(step.content)"></div>
    </div>
</template>

<script>
export default {
    name: "vue-onboarding-content",

    props: {
        step: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {};
    },
};
</script>

<style lang="scss">
.vue-onboarding__content {
    padding: 16px;
    margin-bottom: -5px !important;
    border-left: 1px solid #F3F2F7;
    border-right: 1px solid #F3F2F7;
}
</style>



// WEBPACK FOOTER //
// src/components/VueOnboarding/VueOnboardingContentPerPage.vue